
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  getPiCombinedUnit,
  getSupplierProduct,
  putPiCombinedUnit
} from "@/api/proforma";
import { writeOff,poWriteOff } from "@/api/purchase-order";
import { deepClone } from "@/utils/deepClone";

@Component({
  name: "ModifyDiscounts"
})
export default class extends Vue {
  @Prop({ default: false }) private show: boolean;
  @Prop({ default: "核销" }) private title: "";
  @Prop({ default: {} }) private selectedItem: {} | any;

  @Watch("show", { immediate: true })
  private async watchData() {
    if ((this.selectedItem as any).id && this.show) {
      await this.writeOff();
    }
  }

  private form = {} as any;
  private infoFields = [
    {
      label: "当前采购订单号",
      prop: "code",
      key: "code",
      show: true,
      disabled: false
    },
    {
      label: "货款金额",
      prop: "paymentAmount",
      key: "paymentAmount",
      show: true,
      disabled: false
    },
    {
      label: "实际交货金额",
      prop: "actualDeliveryAmount",
      key: "actualDeliveryAmount",
      show: true,
      disabled: false
    },
    {
      label: "交货进度",
      prop: "deliveryProgress",
      key: "deliveryProgress",
      show: true,
      disabled: false
    },
    {
      label: "付款剩余",
      prop: "paymentRemaining",
      key: "paymentRemaining",
      show: true,
      disabled: false
    }
  ] as any;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[]
  };
  public tableCol = [
    {
      label: "装箱单号",
      prop: "hqPackingListCode",
      key: "hqPackingListCode",
      show: true,
      disabled: false
    },
    {
      label: "数量",
      prop: "quantity",
      key: "quantity",
      show: true,
      disabled: false
    },
    {
      label: "货款金额",
      prop: "paymentAmount",
      key: "paymentAmount",
      show: true,
      disabled: false
    },
    {
      label: "付款单号",
      prop: "paymentVoucherCode",
      key: "paymentVoucherCode",
      show: true,
      disabled: false
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        { name: "下载箱单", code: '', click: "handleDownload" }
      ],
      show: true,
      disabled: false,
      width: 120
    }
  ] as any;
  public tableCol2 = [
    {
      label: "索赔抵扣",
      prop: "claimDeductions",
      key: "claimDeductions",
      show: true,
      disabled: false
    },
    {
      label: "其他费用",
      prop: "otherFee",
      key: "otherFee",
      show: true,
      disabled: false
    }

  ] as any;

  private close() {
    this.$emit("update:show", false);
  }

  private open() {
    this.$emit("update:show", true);
  }

  private async writeOff() {
    const res: any = await writeOff(this.selectedItem.id, {});
    this.form = res;
  }

  private async submitForm(): Promise<void> {
    this.$confirm("采购订单一旦核销，将禁止一切修改删除操作、无法再上传装箱单，且无法被撤销，请确认", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(async () => {
        await poWriteOff(this.selectedItem.id).then(res => {
          this.$message({
            type: "success",
            message: "核销成功"
          });
          this.close();
        }).catch(err => {
          console.log(err);
        })
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消核销"
        });
      });

  }

  private onSelectionChange(rows: any[]) {
    console.log(rows);
  }

  public async handleDelete(scope) {
    this.$notify({
      title: "成功",
      message: "删除成功",
      type: "success",
      duration: 2000
    });
  }


  // 更新组合单位
  private async putPiCombinedUnit() {
    const {
      hqProductName,
      supplier,
      shipmentQuantity,
      deliveryQuantity,
      deliveryChineseUnit,
      shipmentChineseUnit,
      deliveryEnglishUnit,
      shipmentEnglishUnit
    } = this.form;
    let params = {
      hqProductName,
      supplierAbbr: supplier,
      shipmentQuantity,
      deliveryQuantity,
      deliveryChineseUnit,
      shipmentChineseUnit,
      deliveryEnglishUnit,
      shipmentEnglishUnit
    };
    try {
      await putPiCombinedUnit(this.form.id, params);
      this.$notify({
        title: "成功",
        message: "创建成功",
        type: "success",
        duration: 2000
      });
      this.close();
      this.$emit("success", false);
    } catch {
    }
  }

  private async getPiCombinedUnit() {
    const res: any = await getPiCombinedUnit(this.form.id);
    this.getSupplierProduct(res.supplierId);
  }

  private async getSupplierProduct(supplierId) {
    const res: any = await getSupplierProduct(supplierId, {
      hqProductName: this.form.hqProductName
    });
    this.$set(this.form, "shipmentChineseUnit", res.chineseUnit || "");
    this.$set(this.form, "shipmentEnglishUnit", res.englishUnit || "");
    this.$set(this.form, "shipmentQuantity", 1);
    this.$set(this.form, "deliveryQuantity", 1);
  }
}
